export default "__VITE_PUBLIC_ASSET__af603582__"